import { DialogBoxButtonColor } from "src/shared/models/dialog-box";
import { ShadeService } from "../services/shade.service";

type MotiDialogBoxButtonColor = '' | 'gray' | 'red' | 'green' | 'blue' | 'fuchsia';


export interface MotiDialogBoxButton {
  text: string;
  callback: (input?: string) => void;
  callbackIsDefault?: boolean; // set to true to execute this button's callback if user keys Enter while focused in input box
  color?: MotiDialogBoxButtonColor;
  href?: {
    url: string;
    target?: '_self' | '_blank';
  };
  routerLink?: string;
}


export function makeOkButton(shade: ShadeService): MotiDialogBoxButton {
  return {
    text: 'OK',
    callback: () => {
      shade.closeAll();
    },
    color: DialogBoxButtonColor.Default,
  };
}

export function makeCancelButton(shade?: ShadeService): MotiDialogBoxButton {
  return {
    text: 'Cancel',
    callback: () => {
      shade?.closeAll();
    },
    color: 'gray',
  };
}
